import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { CARRIER_COORDINATION as T } from "@/constants/testIds";

export const faqData = [
  {
    q: "What is carrier coordination?",
    a: "Carrier coordination is the operational process of managing ocean carriers, container bookings and shipment schedules across import and export logistics. It covers everything from requesting freight bookings to confirming sailings, allocating containers, handling shipping documents and tracking ETAs — typically across multiple carriers and trade lanes.",
  },
  {
    q: "How does FreightIQ™ work?",
    a: "FreightIQ™ is the carrier coordination Workspace Product inside DeMaxtore. It centralizes carrier profiles, booking requests, confirmations, container assignments, documentation and shipment visibility into a single, structured Workspace — replacing scattered emails, spreadsheets and follow-up calls.",
  },
  {
    q: "Can I coordinate multiple carriers?",
    a: "Yes. FreightIQ™ is built for multi-carrier freight coordination. You can request bookings across several ocean carriers, compare responses, confirm sailings and manage the full carrier booking management workflow from one place.",
  },
  {
    q: "Can I track container bookings?",
    a: "Yes. Every container booking in FreightIQ™ is tracked with carrier reference, container number, port of loading, port of destination, vessel, cutoff and ETA. Status updates are surfaced through a live notification center, so your team always has current shipment visibility.",
  },
  {
    q: "Does FreightIQ™ support shipment visibility?",
    a: "Absolutely. FreightIQ™ provides end-to-end shipment coordination visibility — booking status, container release, documentation readiness, vessel departure and ETA updates — all in one Workspace view designed for enterprise import operations.",
  },
  {
    q: "How does FreightIQ™ integrate with the DeMaxtore Workspace?",
    a: "FreightIQ™ connects natively with the other DeMaxtore Workspace products — RFQ™, CommodityBid™, Inspection™ and Live Shipment Tracking™. Purchase orders flow into FreightIQ™ automatically, and shipment data flows out to inspection and tracking, giving you one connected operational spine for export logistics coordination.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid={T.faq} className="relative border-t border-slate-line bg-white py-24">
      <div className="mx-auto max-w-4xl px-6 lg:px-10">
        <div className="text-center">
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-blue-brand">FAQ</p>
          <h2 className="mt-4 text-3xl font-semibold text-navy sm:text-4xl lg:text-[44px] lg:leading-[1.08]">
            Frequently Asked Questions
          </h2>
          <p className="mt-5 text-[15px] leading-relaxed text-slate-600">
            Everything import operations teams ask about carrier coordination, freight booking and shipment visibility inside FreightIQ™.
          </p>
        </div>

        <Accordion
          type="single"
          collapsible
          data-testid={T.faqAccordion}
          className="mx-auto mt-12 divide-y divide-slate-line rounded-2xl border border-slate-line bg-white shadow-card"
        >
          {faqData.map((item, i) => (
            <AccordionItem
              key={item.q}
              value={`faq-${i}`}
              data-testid={T.faqItem(i)}
              className="border-none px-5"
            >
              <AccordionTrigger className="text-left text-[15.5px] font-semibold text-navy hover:no-underline data-[state=open]:text-blue-brand">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-[14.5px] leading-relaxed text-slate-600">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
